/* eslint-disable functional/no-try-statement */
import _ from 'lodash';

export default function paramHelper(queryParam: readonly string[] | string): readonly string[] {
  try {
    if (_.isEmpty(queryParam)) {
      return [];
    }
    if (Array.isArray(queryParam)) {
      return queryParam;
    }
    if (queryParam[0] === '[') {
      return JSON.parse((queryParam as string));
    }
    return (queryParam as string).split(',').map((param) => _.trim(param));
  } catch (ex) {
    return [];
  }
}
